<sew-ws-page-content-teaser-simple>
    <div slot="teaser">
        @if (showForm && !showSMBottom) {
            <blog-form [labels]="labels"></blog-form>
            <blog-social-media class="social-media" [headline]="labels?.social_media"></blog-social-media>
        }
        @if (showPodcast && !showSMBottom) {
            <sew-ws-podcast-humian
                theme
                [podcasts]="podcasts"
                [attr.close-aria-label]="podcastCloseAriaLabel"
                [attr.forward-aria-label]="podcastForwardAriaLabel"
                [attr.headline-podcasts]="podcastHeadlinePodcasts"
                [attr.mute-aria-label]="podcastMuteAriaLabel"
                [attr.play-aria-label]="podcastPlayAriaLabel"
                [attr.rewind-aria-label]="podcastRewindAriaLabel"
                [attr.rss-url]="podcastMargin?.['rss-feed']"
            >
            </sew-ws-podcast-humian>
            <blog-social-media class="social-media" [headline]="labels?.social_media"></blog-social-media>
        }
    </div>

    <div slot="content">
        @for (content of contents; track content) {
            @switch (content.type) {
                <!-- text -->
                @case ('text') {
                    <div class="content-wrapper">
                        <blog-text
                            [attr.data-preview-id]="content.preview_id"
                            [content]="content"
                            [breakpoint]="breakpoint"
                        >
                        </blog-text>
                        <blog-fs-add-section
                            [previewId]="content.preview_id"
                            [label]="addSectionLbl"
                            class="fs-add-section"
                        ></blog-fs-add-section>
                    </div>
                }
                <!-- highlight -->
                @case ('highlight') {
                    <div class="content-wrapper">
                        <blog-highlight
                            [highlight]="content"
                            [attr.data-preview-id]="content.preview_id"
                        ></blog-highlight>
                        <blog-fs-add-section
                            [previewId]="content.preview_id"
                            [label]="addSectionLbl"
                            class="fs-add-section"
                        ></blog-fs-add-section>
                    </div>
                }
                <!-- video -->
                @case ('video') {
                    <div class="content-wrapper">
                        <blog-youtube-player
                            [attr.data-preview-id]="content.preview_id"
                            [videoSrc]="content.videoSrc"
                            [caption]="content.title"
                        ></blog-youtube-player>
                        <blog-fs-add-section
                            [previewId]="content.preview_id"
                            [label]="addSectionLbl"
                            class="fs-add-section"
                        ></blog-fs-add-section>
                    </div>
                }
                <!-- quote/cite -->
                @case ('quote') {
                    <div class="content-wrapper">
                        <blog-cite [attr.data-preview-id]="content.preview_id" [cite]="content"></blog-cite>
                        <blog-fs-add-section
                            [previewId]="content.preview_id"
                            [label]="addSectionLbl"
                            class="fs-add-section"
                        ></blog-fs-add-section>
                    </div>
                }
                <!-- audio -->
                @case ('audio') {
                    <div class="content-wrapper">
                        <blog-audio
                            [attr.data-preview-id]="content.preview_id"
                            [audio]="content"
                        ></blog-audio>
                        <blog-fs-add-section
                            [previewId]="content.preview_id"
                            [label]="addSectionLbl"
                            class="fs-add-section"
                        ></blog-fs-add-section>
                    </div>
                }
                <!-- picture -->
                @case ('picture') {
                    <div class="content-wrapper">
                        <blog-picture
                            [attr.data-preview-id]="content.preview_id"
                            [picture]="content"
                        ></blog-picture>
                        <blog-fs-add-section
                            [previewId]="content.preview_id"
                            [label]="addSectionLbl"
                            class="fs-add-section"
                        ></blog-fs-add-section>
                    </div>
                }
                <!-- cta -->
                @case ('call_to_action') {
                    <div class="content-wrapper">
                        <blog-cta
                            [cta]="content"
                            [breakpoint]="breakpoint"
                            [attr.data-preview-id]="content.preview_id"
                        ></blog-cta>
                        <blog-fs-add-section
                            [previewId]="content.preview_id"
                            [label]="addSectionLbl"
                            class="fs-add-section"
                        ></blog-fs-add-section>
                    </div>
                }
            }
        }
    </div>
</sew-ws-page-content-teaser-simple>

@if (showSMBottom) {
    <div class="text-wrapper">
        @if (showForm) {
            <blog-form-tablet
                [txtSubscribe]="txtFormHeader ?? ''"
                (subscribeClicked)="openSubscribeDialog('subscribe-modal')"
            ></blog-form-tablet>
        }
        @if (showPodcast) {
            <sew-ws-podcast-humian
                theme
                [podcasts]="podcasts"
                [attr.close-aria-label]="podcastCloseAriaLabel"
                [attr.forward-aria-label]="podcastForwardAriaLabel"
                [attr.headline-podcasts]="podcastHeadlinePodcasts"
                [attr.mute-aria-label]="podcastMuteAriaLabel"
                [attr.play-aria-label]="podcastPlayAriaLabel"
                [attr.rewind-aria-label]="podcastRewindAriaLabel"
                [attr.rss-url]="podcastMargin?.['rss-feed']"
            >
            </sew-ws-podcast-humian>
        }
        <div class="social-media-container outer-content-wrapper">
            <div class="inner-content-wrapper">
                @if (!isPreview) {
                    <blog-social-media [headline]="labels?.social_media"></blog-social-media>
                }
            </div>
        </div>
    </div>
    @if (showForm) {
        <blog-modal id="subscribe-modal">
            <div class="modal-subscribe-wrapper">
                <div class="form-wrapper form-width">
                    <blog-form [labels]="labels"></blog-form>
                </div>
                <div class="close" (click)="closeSubscribeDialog('subscribe-modal')">
                    <img src="assets/images/close_dark.svg" />
                </div>
            </div>
        </blog-modal>
    }
}
